import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes, IconVariants } from 'components/foundations/Icon';
import css from './SectionsSidebar.css';

const SectionsSidebar = ({ sections, answeredBySectionId, activeSectionId, onSectionClick }) => (
    <div className={css.sidebar}>
        <div className={css.title}>Sections</div>
        <div className={css.list}>
            {sections.map(section => {
                const isActive = section.id === activeSectionId;
                return (
                    <div
                        key={section.id}
                        className={classNames(css.item, { [css.active]: isActive })}
                        onClick={() => onSectionClick(section.id)}
                    >
                        <Icon
                            name={section.icon}
                            size={IconSizes.SMALL}
                            variant={isActive ? IconVariants.ACTIVE : IconVariants.LIGHT}
                            interactive={false}
                            className={css.icon}
                        />
                        <div className={css.name}>{section.name}</div>
                        <div className={css.counter}>
                            {answeredBySectionId[section.id]}/{section.questions.length}
                        </div>
                    </div>
                );
            })}
        </div>
    </div>
);

SectionsSidebar.propTypes = {
    sections: PropTypes.array.isRequired,
    answeredBySectionId: PropTypes.object.isRequired,
    activeSectionId: PropTypes.string,
    onSectionClick: PropTypes.func.isRequired,
};

export default SectionsSidebar;
